import type { FC } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { CheckIcon, CloseIcon } from '@truvhq/ui';

import type { PlanPitch } from '../lib/tierPitch';

export type UpgradePromoLayoutProps = {
  pitch: PlanPitch;
  onCta: () => void;
  onMaybeLater: () => void;
  onDismiss: () => void;
  onViewAllPlans: () => void;
};

export const UpgradePromoModal: FC<UpgradePromoLayoutProps> = ({
  pitch,
  onCta,
  onMaybeLater,
  onDismiss,
  onViewAllPlans,
}) => {
  return (
    <Dialog
      open
      onClose={onDismiss}
      role="dialog"
      aria-modal="true"
      aria-labelledby="upgrade-promo-headline"
      PaperProps={{ className: 'rounded-[24px] max-w-[480px]' }}
    >
      <IconButton
        aria-label="Close upgrade promo"
        className="absolute right-3 top-3 text-grey60"
        onClick={onDismiss}
        size="small"
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle className="px-8 pb-2 pt-10">
        <Typography id="upgrade-promo-headline" variant="h2" className="text-grey100 font-semibold leading-tight">
          {pitch.headline}
        </Typography>
      </DialogTitle>
      <DialogContent className="px-8 pb-2">
        <ul className="mt-2 flex flex-col gap-3">
          {pitch.bullets.map((bullet) => (
            <li key={bullet} className="flex items-start gap-2">
              <CheckIcon className="mt-1 h-4 w-4 flex-none text-primary-main" />
              <Typography variant="body1" className="text-grey80">
                {bullet}
              </Typography>
            </li>
          ))}
        </ul>
      </DialogContent>
      <DialogActions className="flex flex-col gap-2 px-8 pb-8 pt-4 sm:flex-row sm:justify-end">
        <Button onClick={onViewAllPlans} variant="text" className="text-grey60">
          View all plans
        </Button>
        <Button onClick={onMaybeLater} variant="outlined">
          Maybe later
        </Button>
        <Button onClick={onCta} variant="contained" color="primary" autoFocus>
          {pitch.ctaLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
